module.exports = __webpack_public_path__ + "img/purple-1-oval-solid.ad4d90a9.svg";